































































import {Component, Prop, PropSync, Vue} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import {WithholdType} from 'ncp-api-supporter/dist/types/enum';
import {ClaimType} from '@/types/claim';
import {commaNumStringToNumber} from '@/utils/dataReplaceUtils';

interface Form {
  withholdType: WithholdType;
  holdDetailReason?: string;
  returnDeliveryAdjustAmt?: string;
}

@Component({
  components: {
    CompSelectBox,
    CompRadioButton
  }
})
export default class NaverPayReturnHold extends Vue {
  @Prop({required: true})
  private claimType!: ClaimType;

  @PropSync('showNaverPayHoldPopup')
  private showNaverPayHoldPopupSync!: boolean;

  private isAdjustAmountExist = false;
  // TODO: API 나오면 재확인, 옵션 임시 주석
  private withholdTypeSelects = [
    // {
    //   name: '반품 배송비 청구',
    //   value: 'RETURN_DELIVERYFEE'
    // },
    // {
    //   name: '기타 반품 비용 청구',
    //   value: 'EXTRAFEEE'
    // },
    // {
    //   name: '반품 배송비 및 기타 반품 비용 청구',
    //   value: 'RETURN_DELIVERYFEE_AND_EXTRAFEEE'
    // },
    // {
    //   name: '반품 상품 미입고',
    //   value: 'RETURN_PRODUCT_NOT_DELIVERED'
    // },
    // {
    //   name: '기타 사유',
    //   value: 'ETC'
    // },
    // TODO: 교환 네페 API 개발 후 알려주신댔음
    // {
    //   name: '교환 배송비 청구',
    //   value: 'EXCHANGE_DELIVERYFEE'
    // },
    // {
    //   name: '기타 교환 비용 청구',
    //   value: 'EXCHANGE_EXTRAFEE'
    // },
    // {
    //   name: '교환 상품 준비 중',
    //   value: 'EXCHANGE_PRODUCT_READY'
    // },
    // {
    //   name: '교환 상품 미입고',
    //   value: 'EXCHANGE_PRODUCT_NOT_DELIVERED'
    // },
    // {
    //   name: '판매자 확인 필요',
    //   value: 'SELLER_CONFIRM_NEED'
    // },
    // {
    //   name: '구매자 확인 필요',
    //   value: 'PURCHASER_CONFIRM_NEED'
    // },
    // {
    //   name: '판매자 직접 송금',
    //   value: 'SELLER_REMIT'
    // },
    // {
    //   name: '',
    //   value: 'ETC_2'
    // }
  ];
  private adjustAmountRadioOptions = {
    name: 'isAdjustAmountExist',
    data: [
      {
        id: 'status_ALL',
        value: false,
        dispaly: this.$t('입력안함')
      },
      {
        id: 'status_ISSUED',
        value: true,
        dispaly: this.$t('입력함')
      }
    ]
  };

  private formData: Form = {
    withholdType: 'RETURN_DELIVERYFEE',
    holdDetailReason: '',
    returnDeliveryAdjustAmt: '0',
  }

  onClose(){
    this.showNaverPayHoldPopupSync = false;
  }

  onApprove(){
    if(!confirm(this.$t(`CLAIM_POPUP_ASK_${this.claimType}_WITH_HOLD`).toString())){
      return false;
    }

    const {withholdType, holdDetailReason, returnDeliveryAdjustAmt} = this.formData
    const request = {
      pathParams: {
        no: this.$route.query.claimNo.toString()
      },
      data: {
        withholdType,
        holdDetailReason,
        returnDeliveryAdjustAmt: this.isAdjustAmountExist ? commaNumStringToNumber(returnDeliveryAdjustAmt) : 0,
      }
    };

    const approveWithHold = {
      'EXCHANGE': () => this.$api.putClaimsNoNaverPayExchangeWithhold(request),
      'RETURN': () => this.$api.putClaimsNoNaverPayReturnsWithhold(request),
    }

    approveWithHold[this.claimType]().then(()=>{
      alert(this.$t('CLAIM_POPUP_ALERT_NAVER_PAY_PROCESS_SUCCESS'));
      location.reload();
    })
  }

  private created(){
    this.setWithholdTypeSelects()
  }

  private setWithholdTypeSelects(){
    const returnSelects = [
      {
        name: '반품 배송비 청구',
        value: 'RETURN_DELIVERYFEE'
      },
      {
        name: '기타 반품 비용 청구',
        value: 'EXTRAFEEE'
      },
      {
        name: '반품 배송비 및 기타 반품 비용 청구',
        value: 'RETURN_DELIVERYFEE_AND_EXTRAFEEE'
      },
      {
        name: '반품 상품 미입고',
        value: 'RETURN_PRODUCT_NOT_DELIVERED'
      },
      {
        name: '기타 사유',
        value: 'ETC'
      }
    ]

    // 교환, 반품에 따라 셀렉박스 출력이 다름. TODO: 문의 후 대기중
    const exchangeSelects = [
      {
        name: '교환 배송비 청구',
        value: 'EXCHANGE_DELIVERYFEE'
      },
      {
        name: '기타 교환 비용 청구',
        value: 'EXCHANGE_EXTRAFEE'
      },
      {
        name: '교환 상품 준비 중',
        value: 'EXCHANGE_PRODUCT_READY'
      },
      {
        name: '교환 상품 미입고',
        value: 'EXCHANGE_PRODUCT_NOT_DELIVERED'
      },
      {
        name: '기타 사유',
        value: 'ETC'
      }
    ]

    this.formData.withholdType = this.isReturnClaim ? 'RETURN_DELIVERYFEE' : 'EXCHANGE_DELIVERYFEE';
    this.withholdTypeSelects = this.isReturnClaim ? [...returnSelects] : [...exchangeSelects];
  }

  private get isReturnClaim(){
    return this.claimType === 'RETURN'
  }

  private onChangeReasonType(value){
    const adjustTargetReasons = ['EXCHANGE_EXTRAFEE', 'EXTRAFEEE', 'RETURN_DELIVERYFEE_AND_EXTRAFEEE']
    this.isAdjustAmountExist = adjustTargetReasons.includes(value);
  }

  private onlyCommaNumber(event: Event) {
    const $input = event.target as HTMLInputElement;

    if ($input.value === '' || $input.value === '0') {
      $input.value = '0';
      return;
    }

    $input.value = $input.value
      .toString()
      .replace(/\D/g, '')
      .replace(/^0+/, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
